import { SELECT_ALL } from "commons/table/Constants";
import { isCollectionNullOrEmpty } from "services/UtilityService";
import { AgentWorkspaceConstants } from "lookup/AgentWorkspaceConstants";

/** react-select may return one option or an array depending on isMulti. */
export function normalizeSelectValue(selected) {
  if (selected == null) {
    return [];
  }
  return Array.isArray(selected) ? selected : [selected];
}

/**
 * Builds the {@code filtered} array for {@code POST /agent-workspace/call-group/next}.
 * Values are abbreviation / enum strings, matching the list API shape.
 *
 * @param {Record<string, object|object[]|null>} selections react-select values by filter id
 * @returns {{id: string, value: string[]}[]}
 */
export function buildNextCallGroupFiltered(selections) {
  const filtered = [];
  for (const id of AgentWorkspaceConstants.AGENT_NEXT_CALL_GROUP_FILTER_IDS) {
    const values = normalizeSelectValue(selections[id])
      .map((option) => option.value)
      .filter((value) => (id === "clientNameAbbreviation" ? value !== SELECT_ALL : true));
    if (isCollectionNullOrEmpty(values)) {
      continue;
    }
    filtered.push({ id, value: values });
  }
  return filtered;
}

/**
 * Maps list-filters option rows to react-select `{ value, label }` options.
 */
export function toSelectOptions(filterRows) {
  if (!filterRows) {
    return [];
  }
  return filterRows.map((row) => ({
    value: row.id,
    label: row.value,
  }));
}

/**
 * Restricts client options to those mapped to the selected customers.
 */
export function clientOptionsForCustomers(filtersMeta, selectedCustomers) {
  const allClients = toSelectOptions(filtersMeta?.clientNameAbbreviation);
  const customers = normalizeSelectValue(selectedCustomers);
  if (isCollectionNullOrEmpty(customers)) {
    return allClients;
  }
  const selectedCustomerIds = customers.map((c) => c.value);
  const mapping = (filtersMeta?.customerClientMapping || []).filter((m) =>
    selectedCustomerIds.includes(m.id)
  );
  const allowedClientIds = new Set(
    mapping.reduce((result, entry) => result.concat(entry.value || []), [])
  );
  return allClients.filter((client) => allowedClientIds.has(client.value));
}
